module.exports = __webpack_public_path__ + "img/kiki-flying2.bc4d034a.gif";